export class CheckHasRestrictionsRequest {
    public idHealthcareAgreement: number;
    public idProcedure: number;
    public idPatient: number;
    public guideType: number;
}